// Lightweight validators for Figma API responses — intentionally not comprehensive.
// For example, Node recurses via `children` but we only validate top-level fields.

import { arrayOf, maybe, objectOf, recordOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";
import type { Component, ComponentSet, Style } from "@figma/rest-api-spec";

const isDocumentationLink = objectOf({
  uri: string,
});

const isComponent = objectOf({
  key: string,
  name: string,
  description: string,
  componentSetId: maybe(string),
  documentationLinks: arrayOf(isDocumentationLink),
  remote: boolean,
});

const isComponentSet = objectOf({
  key: string,
  name: string,
  description: string,
  documentationLinks: maybe(arrayOf(isDocumentationLink)),
  remote: maybe(boolean),
});

const isStyle = objectOf({
  key: string,
  name: string,
  description: string,
  remote: boolean,
  styleType: string,
});

const isNode = objectOf({
  id: string,
  name: string,
  type: string,
  visible: maybe(boolean),
});

const isNodeEntry = objectOf({
  document: isNode,
  components: recordOf<Record<string, Component>>(isComponent),
  componentSets: recordOf<Record<string, ComponentSet>>(isComponentSet),
  schemaVersion: number,
  styles: recordOf<Record<string, Style>>(isStyle),
});

export const isPostAppGroupIdFigmaFileNodesResult = objectOf({
  name: string,
  role: string,
  lastModified: string,
  editorType: string,
  thumbnailUrl: string,
  version: string,
  nodes: recordOf(isNodeEntry),
});
